import type { MouseEvent, MutableRefObject } from 'react';
import { useCallback } from 'react';
import * as React from 'react';

import type { BaseComponentProps } from '@coursera/cds-common';
import type { ProductCardProps } from '@coursera/cds-core';
import { ProductCard as CDSProductCard } from '@coursera/cds-core';

import type { TrackingProps } from './BaseComponent';
import useTracker from './useTracker';
import useVisibilityTracker from './useVisibilityTracker';

type OwnProps = TrackingProps<'click_product_card' | 'view_product_card'>;
type Props = OwnProps & Omit<ProductCardProps & Omit<BaseComponentProps<'div'>, 'title'>, keyof OwnProps>;

/**
 * ProductCard is a wrapper around CDS ProductCard that tracks view and click events.
 */
const ProductCard = ({ onClick, trackingData, trackingOptions, ...props }: Props) => {
  const track = useTracker('click_product_card', trackingData, trackingOptions);
  const ref: MutableRefObject<HTMLDivElement | null> = useVisibilityTracker('view_product_card', trackingData);

  const handleClick = useCallback<(...args: $TSFixMe[]) => $TSFixMe>(
    (event: MouseEvent<HTMLDivElement>) => {
      track();
      onClick?.(event);
    },
    [onClick, track]
  );

  return <CDSProductCard {...props} onClick={handleClick} ref={ref} />;
};

export type { Props };

export default ProductCard;
